const BigPanda = [
  {
    name: 'app_key',
    label: 'App Key',
    type: 'text',
    required: true,
    helpText:
      "Enter the app key for this channel. BigPanda creates this key when you're configuring the channel.",
    errorText: 'Please enter app key.',
  },
  {
    name: 'token',
    label: 'Token',
    type: 'text',
    required: true,
    helpText: 'Enter the token for your BigPanda Account.',
    errorText: 'Please enter token',
  },
];

const DataDog = [
  {
    name: 'api_key',
    label: 'Api Key',
    type: 'text',
    required: true,
    helpText:
      "Enter the api key for this channel. DataDog creates this key when you're configuring the channel.",
    errorText: 'Please enter api key',
  },
];

const PagerDuty = [
  {
    name: 'service_key',
    label: 'Integration Key',
    type: 'text',
    required: true,
    helpText:
      "Enter the integration key for this channel. PagerDuty creates this key when you're configuring the channel.",
    errorText: 'Integration Key must be 32 alpha-numeric characters.',
  },
];

const GoogleChat = [
  {
    name: 'webhook_url',
    label: 'Webhook URL',
    type: 'text',
    required: true,
    helpText:
      'Enter the webhook URL for the Google Chat space where you want to receive messages.\nGoogle Chat provides a unique webhook URL for each space.',
    errorText: 'Please enter a valid webhook URL.',
  },
];

const PartnerFields = {
  BigPanda,
  DataDog,
  PagerDuty,
  GoogleChat,
};

export default function getDefaultFields(partnerName) {
  return PartnerFields[partnerName];
}
